import googleFontsLoader from '../../helpers/google-fonts.js';
import { select } from '@wordpress/data';

export const boxShadow = (shadow,getView,shadowHover='') => {
    const bshadow = shadow?.[getView];
    const bshadowHover = shadowHover?.[getView];
    if (!bshadow || Object.keys(bshadow).length === 0) {
        return {};
    }
    const boxShadowStyle = bshadow?.elements?.elevation === "default"?{boxShadow:bshadow?.css}:{};
    return boxShadowStyle;

}

const handleValue = (val) => {

  if (typeof val === 'string') {
      
    if (/^\d+px$/.test(val)) {
        return val;
    }
     if (val.startsWith('var:preset|')) {
      const parts = val.split('|');
      if (parts.length === 3) {
        const presetType = parts[1]; // e.g., 'padding'
        const presetKey = parts[2];  // e.g., '30'
        // Format the value dynamically as per your requirement
        return `var(--wp--${presetType}-${presetKey})`;
      }
    }

  }

  return val;
};

export const dimensions = (dim, getView) => {
  const value = dim?.[getView];

  if (!value || Object.keys(value).length === 0) {
      return '0 0 0 0';
  }

  const top = handleValue(value.top) || 0;
  const right = handleValue(value.right) || 0;
  const bottom = handleValue(value.bottom) || 0;
  const left = handleValue(value.left) || 0;

  return `${top} ${right} ${bottom} ${left}`;
};

export const borderStyle = (borderData, getView, mainBorder = {}) => {
        const value = borderData?.[getView];
        const valueHover = mainBorder?.[getView];
        
        if (!value || Object.keys(value).length === 0) {
            return {}; // Return empty object if value is empty
        }
    
        // Generate the full border property
        const borderParts = [
            value?.width !== undefined ? value.width : valueHover?.width,
            value?.style !== undefined ? value.style : valueHover?.style,
            value?.color !== undefined ? value.color : valueHover?.color,
        ].filter(Boolean).join(" ");
    
        // Check if border is uniform (single value) or per-side object
        const borderStyle = value?.top
            ?  Object.entries(value).reduce((acc, [key, val]) => {
                acc[`border${key.charAt(0).toUpperCase() + key.slice(1)}`] = [
                    val?.width !== undefined ? val.width : valueHover?.[key]?.width,
                    val?.style !== undefined ? val.style : valueHover?.[key]?.style,
                    val?.color !== undefined ? val.color : valueHover?.[key]?.color,
                ].filter(Boolean).join(" "); // Avoid undefined values
                return acc;
            }, {}):
            { border: borderParts } // Apply full border if width exists
            ;
    
        return borderStyle;
};
 
export const borderRadiusStyle = (radiusData,getView,radiusDataHover={}) => {
        const borderRadius = radiusData?.[getView];
        const borderRadiusHover = radiusDataHover?.[getView];

        if (!borderRadius || Object.keys(borderRadius).length === 0) {
            // If object is empty, return default padding
            return {};
        }
            
    const borderRadiusStyle = borderRadius?.width
    ? { borderRadius: borderRadius.width }
    :  {
        borderTopLeftRadius: borderRadius?.topLeft !== undefined ? borderRadius.topLeft : borderRadiusHover?.topLeft || "0px",
        borderTopRightRadius: borderRadius?.topRight !== undefined ? borderRadius.topRight : borderRadiusHover?.topRight || "0px",
        borderBottomLeftRadius: borderRadius?.bottomLeft !== undefined ? borderRadius.bottomLeft : borderRadiusHover?.bottomLeft || "0px",
        borderBottomRightRadius: borderRadius?.bottomRight !== undefined ? borderRadius.bottomRight : borderRadiusHover?.bottomRight || "0px",
    };
            return borderRadiusStyle;
}
 
export  const VayuBlocksCssJustify = (alignment,getView) => {
    return (alignment && alignment[getView] !== undefined) 
    ? { justifyContent: alignment[getView] } 
    : {};
}

export  const VayuBlocksCssTextAlign = (alignment,getView) => {
    return (alignment && alignment[getView] !== undefined) 
    ? { textAlign: alignment[getView] } 
    : {};
}

export const borderWidthStyle = (radiusData, getView, radiusDataHover = {}) => {
    const borderRadius = radiusData?.[getView];
    const borderRadiusHover = radiusDataHover?.[getView];

    if (!borderRadius || Object.keys(borderRadius).length === 0) {
        return {};
    }

    // Function to check if value already has a unit
    const addPxIfNeeded = (value) => {
        if (typeof value !== "string") return `${value}px`; // Handle number values
        return /px|%|em|rem|vw|vh$/.test(value) ? value : `${value}px`;
    };

    const borderRadiusStyle = {
        borderTopWidth: borderRadius?.top !== undefined ? addPxIfNeeded(borderRadius.top) : addPxIfNeeded(borderRadiusHover?.top || "0px"),
        borderRightWidth: borderRadius?.right !== undefined ? addPxIfNeeded(borderRadius.right) : addPxIfNeeded(borderRadiusHover?.right || "0px"),
        borderBottomWidth: borderRadius?.bottom !== undefined ? addPxIfNeeded(borderRadius.bottom) : addPxIfNeeded(borderRadiusHover?.bottom || "0px"),
        borderLeftWidth: borderRadius?.left !== undefined ? addPxIfNeeded(borderRadius.left) : addPxIfNeeded(borderRadiusHover?.left || "0px"),
    };

    return borderRadiusStyle;
};

export const VayuBlocksCssborderFrame = (frameData, getView) => { 

    if (!frameData || typeof frameData !== "object") {
        return {}; // Return empty styles if frameData is undefined or not an object
    }
  
    let styles = { ...borderRadiusStyle(frameData.radius, getView) };

    if (frameData.active === 'color') {
        return {
            ...styles,
            ...(frameData.border ? borderStyle(frameData.border, getView) : {}),
        };
    } else if (frameData.active === 'image' && frameData.image) {
        const imageSize = frameData.image.size?.[getView] || 15; 
        const imagePlace = frameData.image.place?.[getView] || 50;

        const addPxIfNeeded = (value) => {
            if (value === 0) return "5px"; // If value is exactly 0, set it to "5px"
            if (typeof value === "number") return `${value}px`;
            if (typeof value === "string" && /px|%|em|rem|vw|vh$/.test(value)) return value;
            return value ? `${value}px` : "5px"; // Default fallback "5px"
        };

        const imageWidthTop = addPxIfNeeded(frameData.image.width?.[getView]?.top);
        const imageWidthLeft = addPxIfNeeded(frameData.image.width?.[getView]?.left);
        const imageWidthRight = addPxIfNeeded(frameData.image.width?.[getView]?.right);
        const imageWidthBottom = addPxIfNeeded(frameData.image.width?.[getView]?.bottom);

        return {
            ...styles,
            borderImage: frameData.image.url === 'custom'
                ? `url(${frameData.image.customImage || ''}) ${imageSize}% / ${imageWidthTop} ${imageWidthBottom} ${imageWidthLeft} ${imageWidthRight} ${frameData.image.type || ''}`
                : `url(${frameData.image.url || ''}) ${imageSize || 3}% / ${imageWidthTop} ${imageWidthBottom} ${imageWidthLeft} ${imageWidthRight} ${frameData.image.type || ''}`,

            borderImageOutset: addPxIfNeeded(imagePlace),
            opacity: frameData.image?.opacity,
        };
    } 

    else if (frameData.active === 'gradient' && frameData.gradient) {
        return {
            ...styles,
            ...(frameData.gradient.width ? borderWidthStyle(frameData.gradient.width, getView) : {}),
            borderImage: `${frameData.gradient.color || 'transparent'} 30%`,
        };
    }

    return styles; // If no conditions match, return the styles (default)
};

export const VayuBlocksInfiniteAnimation = (animationData) => {

    if (!animationData || typeof animationData !== "object") {
        return {}; // Return empty styles if animationData is undefined or not an object
    }

    const animationClassMap = {
        "vayu_blocks_none_compoents_animation": {
          "one-time": "vayu-blocks-animation-none-one-time",
          "without-hvr": "vayu-blocks-animation-icon-none-without-hvr",
		  "with-hvr": "vayu-blocks-animation-icon-none-with-hvr"
		},
		"vayu_blocks_icon-bounce_compoents_animation": {
		  "one-time": "vayu-blocks-animation-icon-bounce-one-time",
		  "without-hvr": "vayu-blocks-animation-icon-bounce-without-hvr",
		  "with-hvr": "vayu-blocks-animation-icon-bounce-with-hvr"
		},
		"vayu_blocks_icon-bounce-left_compoents_animation": {
		  "one-time": "vayu-blocks-animation-icon-bounce-left-one-time",
		  "without-hvr": "vayu-blocks-animation-icon-bounce-left-without-hvr",
		  "with-hvr": "vayu-blocks-animation-icon-bounce-left-with-hvr"
		},
		"vayu_blocks_circleburst_compoents_animation": {
		  "one-time": "vayu-blocks-animation-circleburst-one-time",
		  "without-hvr": "vayu-blocks-animation-circleburst-without-hvr",
		  "with-hvr": "vayu-blocks-animation-circleburst-with-hvr"
		},
		"vayu_blocks_clipReveal_compoents_animation": {
		  "one-time": "vayu-blocks-animation-clipReveal-one-time",
		  "without-hvr": "vayu-blocks-animation-clipReveal-without-hvr",
		  "with-hvr": "vayu-blocks-animation-clipReveal-with-hvr"
		},
		"vayu_blocks_clipRevealTop_compoents_animation": {
		  "one-time": "vayu-blocks-animation-clipRevealTop-one-time",
		  "without-hvr": "vayu-blocks-animation-clipRevealTop-without-hvr",
		  "with-hvr": "vayu-blocks-animation-clipRevealTop-with-hvr"
		},
		"vayu_blocks_clipRevealBottom_compoents_animation": {
		  "one-time": "vayu-blocks-animation-clipRevealBottom-one-time",
		  "without-hvr": "vayu-blocks-animation-clipRevealBottom-without-hvr",
		  "with-hvr": "vayu-blocks-animation-clipRevealBottom-with-hvr"
		},
		"vayu_blocks_clipRevealRight_compoents_animation": {
		  "one-time": "vayu-blocks-animation-clipRevealRight-one-time",
		  "without-hvr": "vayu-blocks-animation-clipRevealRight-without-hvr",
		  "with-hvr": "vayu-blocks-animation-clipRevealRight-with-hvr"
		},
		"vayu_blocks_pulse_compoents_animation": {
		  "one-time": "vayu-blocks-animation-pulse-one-time",
		  "without-hvr": "vayu-blocks-animation-pulse-without-hvr",
		  "with-hvr": "vayu-blocks-animation-pulse-with-hvr"
		},
		"vayu_blocks_spin_compoents_animation": {
		  "one-time": "vayu-blocks-animation-spin-one-time",
		  "without-hvr": "vayu-blocks-animation-spin-without-hvr",
		  "with-hvr": "vayu-blocks-animation-spin-with-hvr"
		},
		"vayu_blocks_flip_compoents_animation": {
		  "one-time": "vayu-blocks-animation-flip-one-time",
		  "without-hvr": "vayu-blocks-animation-flip-without-hvr",
		  "with-hvr": "vayu-blocks-animation-flip-with-hvr"
		},
		"vayu_blocks_3dflip_compoents_animation": {
		  "one-time": "vayu-blocks-animation-3dflip-one-time",
		  "without-hvr": "vayu-blocks-animation-3dflip-without-hvr",
		  "with-hvr": "vayu-blocks-animation-3dflip-with-hvr"
		},
		"vayu_blocks_swing_compoents_animation": {
		  "one-time": "vayu-blocks-animation-swing-one-time",
		  "without-hvr": "vayu-blocks-animation-swing-without-hvr",
		  "with-hvr": "vayu-blocks-animation-swing-with-hvr"
		},
		"vayu_blocks_ripple_compoents_animation": {
		  "one-time": "vayu-blocks-animation-ripple-one-time",
		  "without-hvr": "vayu-blocks-animation-ripple-without-hvr",
		  "with-hvr": "vayu-blocks-animation-ripple-with-hvr"
		}
	};
	  
    const animation = animationData?.infinite.value || 'none';
    const animationHover = animationData?.infinite?.hovertype || 'without-hvr';

	let iconAnimationclass = animationClassMap[animation]?.[animationHover] || '';

    return iconAnimationclass;

}

export const VayuBlocksTypography = (typography, getView  ) => {
    if (!typography || typeof typography !== "object") {
      return {};
    }
  
    const view = getView || "Desktop";
  
    const {
      fonts,
      fontSize,
      appearance,
      lineHeights,
      letterSpacing,
      decoration,
      orientation,
      letterCase,
    } = typography;
  
    let styles = {};
  
    if (fonts?.[view]) {
      googleFontsLoader.attach();
      googleFontsLoader.loadFontToBrowser( fonts?.[view], 'regutlar');
      styles.fontFamily = fonts[view];
    } else {
      styles.fontFamily = 'sans-serif';
    }
  
    if (fontSize?.[view]) {
      styles.fontSize = fontSize[view];
    }
  
    if (appearance?.[view]) {
      styles = {
        ...styles,
        ...appearance[view]?.style
      }
    }
  
    if (lineHeights?.[view]) {
      styles.lineHeight = lineHeights[view];
    }
  
    if (letterSpacing?.[view]) {
      styles.letterSpacing = letterSpacing[view];
    }
  
    if (decoration?.[view]) {
      styles.textDecoration = decoration[view];
    }
  
    if (orientation?.[view]) {
      styles.writingMode = orientation[view];
    }
  
    if (letterCase?.[view]) {
      styles.textTransform = letterCase[view];
    }
  
    return styles;
};
  
export const background = (bg = {}, hover = false, normal={}) => {
  const style = {};
  
  const type = bg.type || 'color';

  if (type === 'color' && bg.color) {
      style.background = bg.color;
  }else if (type === 'gradient' && bg.gradient) {
      style.background = bg.gradient;
  } else if (type === 'media' && bg.image?.url) {
      style.background = `url(${bg.image?.url})`;

      style.backgroundRepeat = bg.image?.repeat || 'no-repeat';
      style.backgroundSize = bg.image?.size || 'cover';
      style.backgroundAttachment = bg.image?.attachment || 'scroll';
      style.backgroundPosition = bg.image?.focalPoint
          ? `${bg.image?.focalPoint.x * 100}% ${bg.image?.focalPoint.y * 100}%`
          : 'center';

      if (bg?.color) {
        style.backgroundColor = bg.color;
      }
  } 
  
  if(hover && type != 'media' ){
    if(normal){
      style.backgroundRepeat = normal.image?.repeat || 'no-repeat';
      style.backgroundSize = normal.image?.size || 'cover';
      style.backgroundAttachment = normal.image?.attachment || 'scroll';
      style.backgroundPosition = normal.image?.focalPoint
          ? `${normal.image?.focalPoint.x * 100}% ${normal.image?.focalPoint.y * 100}%`
          : 'center';
    }else{
      style.backgroundRepeat = 'intial';
      style.backgroundSize = 'initial';
      style.backgroundAttachment = 'initial';
      style.backgroundPosition= 'initial';
    }
   
  }

  return style;
};

export const position = (position, view) => {
  
    let computedPosition = position?.value;
    if (computedPosition === 'inherit' || computedPosition === 'initial') {
      computedPosition = 'relative';
    }
    
    let style = {
      position: computedPosition || 'relative',
      zIndex : position?.zIndex?.[view]|| 0,
    };

    if(position?.value==='absolute' || position?.value === 'fixed'){
      // Horizontal positioning: left or right
      if (position?.horiori) {
        const offset = position[`offset${position.horiori}`]?.[view] || '';
        hasNumber(offset) && (style[position.horiori] = `${offset}`);
      }

      if (position?.vertiori) {
          let offset = position[`offset${position.vertiori}`]?.[view] || '';

          if (hasNumber(offset)) {
            style[position.vertiori] = offset;
          }
      }
    }
 
  return style;
};

export const flex = (flex, view) => {
  let style = {};

  style.alignSelf = flex?.alignself?.[view] || 'inherit'; 

  if (flex?.order?.[view]) {
    switch (flex?.order?.[view]) {
      case 'start':
        style.order = -9999;
        break;
      case 'end':
        style.order = 9999;
        break;
      case 'custom':
        style.order = flex?.customorder?.[view] || 0;
        break;
      default:
        style.order = 0;
    }
  }

  if (flex?.size?.[view]) {
    switch (flex?.size?.[view]) {
      case 'none':
          style['--flex-Grow'] = 1;
          style['--flex-Shrink'] = 1;
          style['--flex-Basis'] = 'auto';
        break;
      case 'grow':
        style['--flex-Grow'] = 1;
        style['--flex-Shrink'] = 0;
        style['--flex-Basis'] = 'auto';
        break;
      case 'shrink':
        style['--flex-Grow'] = 0;
        style['--flex-Shrink'] = 1;
        style['--flex-Basis'] = 'auto';
        break;
      case 'custom':
        style['--flex-Grow'] = flex?.flexgrow?.[view] || 1;
        style['--flex-Shrink'] = flex?.flexshrink?.[view] || 1;
        style['--flex-Basis'] = 'auto';
        break;
      default:
        style['--flex-Grow'] = 0;
        style['--flex-Shrink'] = 0;
        style['--flex-Basis'] = 'auto';
    }
  }else{
     style['--flex-Grow'] = 'initial';
      style['--flex-Shrink'] = 'initial';
      style['--flex-Basis'] = 'initial';
  }

  style.flex = 'var(--flex-Grow) var(--flex-Shrink) var(--flex-Basis)';
  return style;
};

export const size = (size, type = 'width', view, boxed = false) => {
	if (!size || !size?.type) return undefined;

	const currentType = size.type;

	// If boxed is false or currentType is not boxed, continue
	if (!boxed || currentType === 'full') {
		const value = size?.[currentType]?.[type]?.[view];
		return hasNumber(value) ? value : undefined;
	}else if (boxed & currentType === 'boxed'){
    const value = size?.[currentType]?.[type]?.[view];
		return hasNumber(value) ? value : undefined;
  }
	
	return undefined;
};

const hasNumber = (val) => {
	return typeof val === 'string' && /\d/.test(val);
};

export const getResponsiveRangeValue = (valueObject, device = 'Desktop') => {
	if (valueObject && typeof valueObject === 'object' && valueObject.hasOwnProperty(device)) {
	  return valueObject[device];
	}
	return '';
};

export const widthStyle = (val, view) => {
  const widthtype = val?.value;
  const style = {};

  if (widthtype === 'inlinewidth') {
    style.display = 'inline-flex';
    style.maxWidth = 'fit-content';
  } else if (widthtype === 'customwidth') {
    style.width = val?.customWidth?.[view] || val?.customWidth || 'auto';
  }

  return style;
};

